import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconForkSpoon({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6.75.75v22.5M9.75.75V7.5a3.01 3.01 0 0 1-3 3v0a3.01 3.01 0 0 1-3-3V.75M17.25 10.5v12.75M18.25.75h-2a2 2 0 0 0-2 2V8.5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V2.75a2 2 0 0 0-2-2" /></svg></>;
}
export default IconForkSpoon;